import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { A11yModule } from '@angular/cdk/a11y';

import { PhxOmnifilterComponent } from './omnifilter/phx-omnifilter.component';
import { PhxOmnisearchComponent } from './omnisearch/phx-omnisearch.component';
import { PhxOmnifilterFocusableDirective } from './omnifilter/phx-omnifilter-focusable.directive';

import { PhxDropdownModule } from '../dropdown/phx-dropdown.module';
import { PhxInputModule } from '../input/phx-input.module';
import { PhxTagModule } from '../tag/phx-tag.module';
import { PhxSelectModule } from '../select/select.module';
import { PhxAddonModule } from '../addon/phx-addon.module';
import { PhxToggleModule } from '../toggle/phx-toggle.module';
import { PhxDividerModule } from '../divider/phx-divider.module';
import { PhxBadgeModule } from '../badge/phx-badge.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxMobileSelectModule } from '../mobile-select/mobile-select.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxButtonModule } from '../button/phx-button.module';


@NgModule({
  imports: [
    CommonModule,
    PhxIconModule,
    ScrollingModule,
    A11yModule,
    PhxDropdownModule,
    FormsModule,
    PhxInputModule,
    PhxTagModule,
    PhxSelectModule,
    PhxAddonModule,
    PhxToggleModule,
    PhxDividerModule,
    PhxBadgeModule,
    PhxTooltipModule,
    PhxTranslationsRootModule,
    PhxSpinnerModule,
    PhxMobileSelectModule,
    PhxDividerModule,
    PhxButtonModule
  ],
  declarations: [PhxOmnifilterComponent, PhxOmnifilterFocusableDirective, PhxOmnisearchComponent],
  exports: [PhxOmnifilterComponent, PhxOmnisearchComponent],
})
export class PhxOmniSearchFilterModule { }
